import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'app/components/header/header.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SEGMENTS } from 'app/core/constants/faqs';

@Component({
  selector: 'app-my-knp',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    TranslateModule,
    RouterModule,
  ],
  templateUrl: './my-knp.component.html',
})
export class MyKnpComponent implements OnInit {
  selectedLanguage: any;
  SEGMENTS = SEGMENTS;

  ngOnInit(): void {
    this.selectedLanguage = this.readLocalStorageValue('language');
  }

  switchedLanguage(data: any) {
    this.selectedLanguage = data;
  }

  readLocalStorageValue(key: string) {
    let value = localStorage.getItem(key);
    return value;
  }
}
